import React from 'react';
import HeaderContent from '../HeaderContent/HeaderContent';
import ModalCommon from './ModalCommon';
import { Product } from 'models';
import { imageEmpty } from 'utils/importFile';
import { formatPrice, getFilePath } from 'utils';

interface ModalListCartProps {
  openShowCart: boolean;
  onClose: () => void;
  cartList: Product[];
}

const ModalListCart: React.FC<ModalListCartProps> = ({ openShowCart, onClose, cartList }) => {
  const header = (
    <HeaderContent
      size='sm'
      key='confirm-create-product'
      label='DANH SÁCH SẢN PHẨM'
      contentHeader='Tất cả các danh sách trong đơn hàng đều được hiển thị tại đây'
    />
  );

  return (
    <ModalCommon
      open={openShowCart}
      onClose={onClose}
      onConfirm={() => {}}
      header={header}
      hideFooter
      width={1552}
      showClose
    >
      <div className='flex flex-col gap-3 pt-3 px-6'>
        {cartList?.map((item, index) => (
          <div key={index} className='p-4 rounded-2xl border bg-white grid grid-cols-12 gap-6 items-center'>
            <div className='flex gap-4 col-span-4'>
              <img
                src={
                  item?.productImages?.[0]?.image?.filePath
                    ? `${getFilePath()}/${item.productImages[0].image.filePath}`
                    : imageEmpty
                }
                className='rounded-lg min-w-[60px]  min-h-[60px]  max-w-[60px]  max-h-[60px]'
                alt='Hình sản phẩm'
              />
              <div className='flex flex-col justify-between'>
                <h3 className='text-xl font-bold text-black leading-5 line-clamp-2'>{item.name}</h3>
                <p className='text-[var(--textBlack56)]'>
                  Đơn giá: <span className='text-black font-bold'>{formatPrice(item?.costPrice ?? 0)} VND</span>
                </p>
              </div>
            </div>
            <div className='flex flex-col justify-between h-full text-center col-span-2'>
              <p className='text-[var(--textBlack56)]'>Thương hiệu</p>
              <p className='text-black font-medium'>{item?.brand?.name ?? ''}</p>
            </div>
            <div className='flex flex-col justify-between h-full text-center col-span-2'>
              <p className='text-[var(--textBlack56)]'>Danh mục</p>
              <p className='text-black font-medium'>{item?.category?.name ?? ''}</p>
            </div>
            <div className='flex flex-col justify-between h-full text-center'>
              <p className='text-[var(--textBlack56)]'>Số lượng</p>
              <p className='text-black font-medium'>{item?.quantityBuy ?? 0}</p>
            </div>
            <div className='flex flex-col justify-between h-full text-center'>
              <p className='text-[var(--textBlack56)]'>Đơn vị tính</p>
              <p className='text-black font-medium'>{item?.currencyUnit?.name ?? ''}</p>
            </div>
            <div className='flex flex-col justify-between h-full text-center col-span-2'>
              <p className='text-[var(--textBlack56)]'>Tạm tính</p>
              <p className='text-[var(--primaryColor500)] font-bold'>
                {formatPrice((item?.quantityBuy ?? 0) * (item?.costPrice ?? 0))} VND
              </p>
            </div>
          </div>
        ))}
      </div>
    </ModalCommon>
  );
};

export default ModalListCart;
